function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "edit_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  className: "edit_svg__a",
  transform: "translate(49 67)",
  d: "M0 0h16v16H0z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "edit_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  className: "edit_svg__c",
  d: "M.174 11.477l.028-.001L10.945.484a.3.3 0 01.027-.027l.245-.245a.3.3 0 01.424 0l4.191 4.191a.3.3 0 010 .424l-.245.245-.019.02L4.653 15.864l-.04-.04-.001.045-4.245-.102.001-.015-.038.004zm1.034 3.387l3.181.087 7.65-7.65-3.296-3.297-7.625 7.625zm11.5-8.232l2.008-2.008-3.297-3.296-2.007 2.007z"
}));

function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _ref, _ref2);
}

export default SvgEdit;